import { AlertProps } from "@mui/material";
import { OnboardData } from "../interface/onboard";
import { RepresentativeApplyProps } from "../interface/api";

export function validate_onboarding(
  state_data: OnboardData,
  notification: (message: string, severity?: AlertProps["severity"]) => void
): boolean {
  // validation
  if (!state_data.name) {
    notification("Full name is required", "warning");
    return false;
  }

  if (!state_data.dob) {
    notification("Date of birth is required", "warning");
    return false;
  }

  if (!state_data.gender) {
    notification("Gender is required", "warning");
    return false;
  }

  if (!state_data.state_id) {
    notification("State is required", "warning");
    return false;
  }

  if (!state_data.local_government_id) {
    notification("Local government is required", "warning");
    return false;
  }

  // Example validation: Check if the date of birth is a valid date
  const dob = new Date(state_data.dob);

  // Example validation: Check if the date of birth is within a specific range
  const currentDate = new Date();
  const age = currentDate.getFullYear() - dob.getFullYear();
  if (age < 18) {
    notification("You must be at least 18 years old to proceed", "warning");
    return false;
  }

  return true;
}

export function resps_validate(respData: RepresentativeApplyProps): {
  bool: boolean;
  text: string;
} {
  if (respData.position_id === "" || respData.position_id.length === 0) {
    return { bool: false, text: "Position is required" };
  }
  if (
    respData.constituency_id === "" ||
    respData.constituency_id.length === 0
  ) {
    return { bool: false, text: "Constituency is required" };
  }
  if (respData.district_id === "0" || respData.district_id.length === 0) {
    return { bool: false, text: "District is required" };
  }
  if (respData.state_id === "" || respData.state_id.length === 0) {
    return { bool: false, text: "State is required" };
  }
  if (
    respData.local_government_id === "0" ||
    respData.local_government_id.length === 0
  ) {
    return { bool: false, text: "Local Government is required" };
  }
  if (respData.party_id === "0" || respData.party_id.length === 0) {
    return { bool: false, text: "Poilitcal Party is required" };
  }
  if (respData.social_handles.length === 0) {
    return { bool: false, text: "Social Handles are required, atleast One" };
  }

  return { bool: true, text: "" };
}
